import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FinishedOutOrder } from 'src/models/OutOrder';

@Component({
  selector: 'app-sell-order-expedition-details',
  templateUrl: './sell-order-expedition-details.component.html',
  styleUrls: ['./sell-order-expedition-details.component.scss']
})
export class SellOrderExpeditionDetailsComponent implements OnInit {

  @Input() sellOrder: FinishedOutOrder;
  @Output() crateClick = new EventEmitter<string>();
  displayedColumns = ['name', 'action'];
  carouselIndex = 0;
  carouselPageSize = 4;

  constructor() { }

  get canScrollLeft(): boolean {
    return this.carouselIndex > 0;
  }

  get canScrollRight(): boolean {
    return this.carouselIndex + this.carouselPageSize < this.sellOrder?.outOrderCrates?.length;
  }

  carouselPrev() {
    if (this.canScrollLeft) this.carouselIndex--;
  }

  carouselNext() {
    if (this.canScrollRight) this.carouselIndex++;
  }

  ngOnInit(): void {
    this.carouselIndex = 0;
  }

  onCrateClick(crateId: string) {
    this.crateClick.emit(crateId);
  }

}
